import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "manage-area-create-view",
  class: "flex flex-col w-full overflow-hidden h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center w-full py-1.5 pl-6 pr-4 border-b border-gray-lp-2100" }
const _hoisted_3 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6",
  src: _imports_0,
  alt: "back"
}, null, -1)
const _hoisted_5 = { class: "text-xl font-semibold text-gray-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_CreateAreaContainer = _resolveComponent("CreateAreaContainer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", null, [
          _createVNode(_component_router_link, { to: "/pickup-dashboard/manage-area" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.createTitle")), 1)
      ]),
      _createVNode(_component_LpButton, {
        ref: "saveButton",
        title: _ctx.$t('pickupDashboard.manageArea.save'),
        textColor: "white",
        fontWeight: "semibold",
        iconLeft: "ics_o_save",
        customClass: "px-4 py-2",
        compact: "",
        disabled: !_ctx.isFormValid,
        onClick: _ctx.confirmSubmit
      }, null, 8, ["title", "disabled", "onClick"])
    ]),
    _createVNode(_component_CreateAreaContainer, {
      ref: "createAreaContainer",
      isValid: _ctx.isFormValid,
      "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFormValid = $event)),
      form: _ctx.form,
      "onUpdate:form": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form = $event))
    }, null, 8, ["isValid", "form"])
  ]))
}